import '.bx{position:relative;}.ssr-plugin'
import '.u{width:100%;}.ssr-plugin'
import '.gb{min-height:200px;}.ssr-plugin'
import '.c{display:flex;}.ssr-plugin'
import '.g{flex-direction:column;}.ssr-plugin'
import '.d{justify-content:center;}.ssr-plugin'
import '.bq{align-items:flex-start;}.ssr-plugin'
import '.w{padding:2rem;}.ssr-plugin'
import '.c9{background:var(--palette-white);}.ssr-plugin'
import '.ag{overflow:hidden;}.ssr-plugin'
import '.b4{position:absolute;}.ssr-plugin'
import '.j5{top:50%;}.ssr-plugin'
import '.j6{right:1rem;}.ssr-plugin'
import '.j7{transform:translateY(-50%);}.ssr-plugin'
import '.j8{width:120px;}.ssr-plugin'
import '.j9{height:120px;}.ssr-plugin'
import '.ja{z-index:0;}.ssr-plugin'
import '.h{align-items:center;}.ssr-plugin'
import '.i7{z-index:1;}.ssr-plugin'
import '.al{gap:0.5rem;}.ssr-plugin'
import '.jb{max-width:calc(100% - 140px);}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="bx u gb c g d bq w c9 ag"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="b4 j5 j6 j7 j8 j9 ja c h d"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="bx i7 c g bq al jb"
      >
        {/* Bold Number */}
        <Title.H1
          style={{
            fontSize: '4rem',
            fontWeight: '700',
            lineHeight: '100%',
            margin: 0,
            color: 'var(--brand-secondary)',
            fontFamily: 'FunnelDisplay',
          }}
        >
          {number}
        </Title.H1>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--brand-secondary)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
